module.exports = __webpack_public_path__ + "static/media/g-2-d.2e54d07e.jpg";